const REVIEW_FIELDS = [
  {
    slug: 'rating_value',
    text: 'Value for money',
  },
  {
    slug: 'rating_ease',
    text: 'Ease of use',
  },
  {
    slug: 'rating_features',
    text: 'Features',
  },
  {
    slug: 'rating_support',
    text: 'Customer support',
  },
]

export const LIKELIHOOD_FIELD = {
  slug: 'likelihood_to_recommend',
  text: 'Likelihood to recommend',
}

export default REVIEW_FIELDS
